export interface LegalContent {
  success: boolean;
  setting_key: string;
  setting_value: string;
  is_default: boolean;
  last_updated?: string;
}

export interface LegalState {
  model: LegalModel;
  loading: boolean;
  error: string | null;
  productName: string;
}

export class LegalModel {
  static initial(): LegalModel {
    return new LegalModel(null);
  }

  constructor(private data: LegalContent | null = null) {}

  static fromJSON(json: any): LegalModel {
    return new LegalModel({
      success: json.success,
      setting_key: json.setting_key,
      setting_value: json.setting_value,
      is_default: json.is_default,
      last_updated: json.last_updated
    });
  }

  get content(): string {
    return this.data?.setting_value || '';
  }

  get lastUpdated(): string | undefined {
    return this.data?.last_updated;
  }

  get isDefault(): boolean {
    return this.data?.is_default || false;
  }

  isEmpty(): boolean {
    return !this.data || !this.data.setting_value;
  }
}
